import DateFnsUtils from '@date-io/date-fns'
import { format, isValid } from 'date-fns'
import { KeyboardDatePicker, KeyboardDatePickerProps, MuiPickersUtilsProvider } from '@material-ui/pickers'

export type DatePickerProps = {
  value: string
  onChange(date: string): void
  label?: string
} & Omit<KeyboardDatePickerProps, 'value' | 'onChange'>

export const DatePicker = (props: DatePickerProps) => {
  const { value, onChange, label, ...rest } = props

  return (
    <div className="flex flex-col w-full">
      {!!label && (
        <label className={`pb-4 text-lg font-semibold ${props.disabled ? 'text-body-lighter' : ''}`} htmlFor={props.id}>
          {label}
        </label>
      )}
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          autoOk
          variant="inline"
          inputVariant="outlined"
          fullWidth
          format="dd/MM/yyyy"
          value={value.length ? value : null}
          onChange={(date) => {
            let newValue = ''

            if (date)
              if (isValid(date)) newValue = format(date, 'yyyy-MM-dd')
              else newValue = date.toDateString()

            onChange(newValue)
          }}
          {...rest}
        />
      </MuiPickersUtilsProvider>
    </div>
  )
}
